import React from 'react';
import { Container, Typography, Box, Paper } from '@mui/material';
import { useTranslation } from 'react-i18next';

const PrivacyPolicy = () => {
  const { t, i18n } = useTranslation('privacyPolicy');

  const formatDate = () => {
    const date = new Date();
    return i18n.language === 'ru'
      ? date.toLocaleDateString('ru-RU')
      : date.toLocaleDateString('en-US');
  };

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Paper sx={{ p: 4 }}>
        <Typography variant="h3" component="h1" gutterBottom>
          {t('title')}
        </Typography>

        <Typography variant="body2" color="text.secondary" gutterBottom>
          {t('lastUpdated', { date: formatDate() })}
        </Typography>

        <Box sx={{ mt: 3 }}>
          <Typography variant="h5" gutterBottom>
            {t('sections.introduction.title')}
          </Typography>
          <Typography variant="body1" paragraph>
            {t('sections.introduction.content')}
          </Typography>

          <Typography variant="h5" gutterBottom sx={{ mt: 3 }}>
            {t('sections.informationWeCollect.title')}
          </Typography>
          <Typography variant="body1" paragraph>
            {t('sections.informationWeCollect.intro')}
          </Typography>
          <Typography variant="body1" component="div" paragraph>
            <ul>
              {t('sections.informationWeCollect.items', { returnObjects: true }).map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </Typography>

          <Typography variant="h5" gutterBottom sx={{ mt: 3 }}>
            {t('sections.cookiesAndAnalytics.title')}
          </Typography>
          <Typography variant="body1" paragraph>
            {t('sections.cookiesAndAnalytics.paragraph1')}
          </Typography>
          <Typography variant="body1" paragraph>
            {t('sections.cookiesAndAnalytics.paragraph2')}
          </Typography>

          <Typography variant="h5" gutterBottom sx={{ mt: 3 }}>
            {t('sections.useOfInformation.title')}
          </Typography>
          <Typography variant="body1" paragraph>
            {t('sections.useOfInformation.intro')}
          </Typography>
          <Typography variant="body1" component="div" paragraph>
            <ul>
              {t('sections.useOfInformation.items', { returnObjects: true }).map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </Typography>

          <Typography variant="h5" gutterBottom sx={{ mt: 3 }}>
            {t('sections.informationProtection.title')}
          </Typography>
          <Typography variant="body1" paragraph>
            {t('sections.informationProtection.content')}
          </Typography>

          <Typography variant="h5" gutterBottom sx={{ mt: 3 }}>
            {t('sections.dataSharing.title')}
          </Typography>
          <Typography variant="body1" paragraph>
            {t('sections.dataSharing.content')}
          </Typography>

          <Typography variant="h5" gutterBottom sx={{ mt: 3 }}>
            {t('sections.yourRights.title')}
          </Typography>
          <Typography variant="body1" paragraph>
            {t('sections.yourRights.intro')}
          </Typography>
          <Typography variant="body1" component="div" paragraph>
            <ul>
              {t('sections.yourRights.items', { returnObjects: true }).map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </Typography>

          <Typography variant="h5" gutterBottom sx={{ mt: 3 }}>
            {t('sections.changesToPolicy.title')}
          </Typography>
          <Typography variant="body1" paragraph>
            {t('sections.changesToPolicy.content')}
          </Typography>

          <Typography variant="h5" gutterBottom sx={{ mt: 3 }}>
            {t('sections.contactUs.title')}
          </Typography>
          <Typography variant="body1" paragraph>
            {t('sections.contactUs.content')}
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
};

export default PrivacyPolicy;
